export default {
    name: 'homepage',
    type: 'document',
    title: 'Homepage',
    fields: [
        {
            name: 'title',
            type: 'string',
            title: 'Title',
            readOnly: true,
            hidden: true,
        },
        {
            name: 'slug',
            type: 'slug',
            title: 'Slug',
            readOnly: true,
            hidden: true,
        },
        {
            title: 'Work',
            name: 'work',
            type: 'array',
            of: [
                {
                    type: 'reference',
                    to: [
                        { type: 'work' },
                    ]
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./schemas/homepage.js